import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined

const ViewCustomer = () => {
    const { id } = useParams(); // Get the customer ID from the URL
    const [customer, setCustomer] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch customer data based on the ID from the URL
        fetch(`${BASE_URL}customers/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setCustomer(data.data); // Set the customer data
                } else {
                    console.error('Failed to fetch customer:', data.message);
                }
            })
            .catch(error => console.error('Error fetching customer:', error));
    }, [id]);

    if (!customer) {
        return <div>Loading...</div>; // Show loading state while data is being fetched
    }

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Customer Details</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <button className="btn btn-secondary" onClick={() => navigate(-1)}>Back</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <label className="form-label">Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={customer.name || 'N/A'}
                                        readOnly
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Phone</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={customer.number1 || 'N/A'}
                                        readOnly
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Address</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={customer.address || 'N/A'}
                                        readOnly
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Area</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={customer.area || 'N/A'}
                                        readOnly
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">City</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={customer.city || 'N/A'}
                                        readOnly
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">State</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={customer.state || 'N/A'}
                                        readOnly
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Pin Code</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={customer.pin_code || 'N/A'}
                                        readOnly
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Firm Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={customer.firm_name || 'N/A'}
                                        readOnly
                                    />
                                </div>
                                {customer.number2 && (
                                    <div className="mb-3">
                                        <label className="form-label">Phone 2</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={customer.number2}
                                            readOnly
                                        />
                                    </div>
                                )}
                                {customer.number3 && (
                                    <div className="mb-3">
                                        <label className="form-label">Phone 3</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={customer.number3}
                                            readOnly
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ViewCustomer;
